import Axios from 'axios';
import { OrderCircle_CONFIG } from '@/js/config.js';
const RESOURCE_NAME = OrderCircle_CONFIG.API_URL + 'chatbot';

export default {
    sendMessage(data) {
        return Axios.post(`${RESOURCE_NAME}/message`, data);
    },
    
    testConnections() {
        return Axios.get(`${RESOURCE_NAME}/test-connections`);
    }
};